import { create } from "zustand";

type ChartDialogOptions = {
  refTime: string | undefined;
};

type ChartDialogState = {
  isOpen: boolean;
  closeDialog: () => void;
  openDialog: (options?: ChartDialogOptions) => void;
  refTime: string | undefined;
  dateFrom: Date | undefined;
  dateTo: Date | undefined;
  setDateFrom: (date: Date) => void;
  setDateTo: (date: Date) => void;
};

const useChartDialogStore = create<ChartDialogState>(set => ({
  isOpen: false,
  refTime: undefined,
  dateFrom: undefined,
  dateTo: undefined,
  closeDialog: () => set({ isOpen: false, dateFrom: undefined, dateTo: undefined }),
  openDialog: (options = { refTime: undefined }) => set({ ...options, isOpen: true }),
  setDateFrom: (date: Date) => set({ dateFrom: date }),
  setDateTo: (date: Date) => set({ dateTo: date }),
}));

export default useChartDialogStore;